<app-nav-bar></app-nav-bar>
<app-settings-modal></app-settings-modal>
<app-side-bar></app-side-bar>

<div class="container">
  <div class="container-coupons">

    <div class="header">
      <h1 class="title" *ngIf="!isEditing">{{'NEW_COUPON' | translate}}</h1>
      <h1 class="title" *ngIf="isEditing">{{'MODIFY_COUPON' | translate}}</h1>
      <app-back-arrow [route]="'/coupons'"></app-back-arrow>
    </div>
    <div class="loading" *ngIf="loading">
      <div class="spinner-border" role="status"></div>
    </div>
    <form *ngIf="!loading" class="form-card" [formGroup]="couponForm" id="parentForm">

      <div class="form-group">
        <label class="form-label" for="couponCode">{{'CODE' | translate}}</label>
        <input type="text" class="form-control" id="couponCode" placeholder="{{'COUPON_CODE' | translate}}" formControlName="couponCode"
          (keyup)="changeObjectValue($event, 'code')" value="{{coupon.couponCode}}">

          <div class="alert-span" *ngIf="couponFormValidation['couponCode'].touched && couponFormValidation['couponCode'].invalid">
            <label class="error-message" *ngIf="couponFormValidation['couponCode'].errors?.['required']">
              {{ 'REQUIRED_FIELD' | translate }}
            </label>
            <label class="error-message" *ngIf="couponFormValidation['couponCode'].errors?.['pattern']">
              {{ 'CODE_VALIDATION' | translate }}
            </label>
          </div>
      </div>

      <div class="form-group">
        <label class="form-label" for="couponType">{{'NAME' | translate}}</label>
        <input type="text" class="form-control" id="couponType" placeholder="{{'COUPON_NAME' | translate }}" formControlName="couponName"
          (keyup)="changeObjectValue($event, 'type')" value="{{coupon.couponType}}">

          <div class="alert-span" *ngIf="couponFormValidation['couponName'].touched && couponFormValidation['couponName'].invalid">
            <label class="error-message" *ngIf="couponFormValidation['couponName'].errors?.['required']">
              {{ 'REQUIRED_FIELD' | translate }}
            </label>
            <label class="error-message" *ngIf="couponFormValidation['couponName'].errors?.['pattern']">
              {{ 'NAME_VALIDATION' | translate }}
            </label>
          </div>
      </div>


      <label class="form-label">{{'COUPON_TYPE' | translate}}</label>
      <div class="form-row form-group">
        <label for="couponByPercetage" class="form-label checkbox-label">
          <input type="radio" id="couponByPercetage" (change)="changeCheckboxState($event, 'percentage')" name="couponType"
            [checked]="coupon.couponByPercentage || true" [disabled]="inputsDisabled">
          {{'PERCENTAGE_COUPON' | translate}}
        </label>

        <label for="couponByPrice" class="form-label checkbox-label">
          <input type="radio" id="couponByPrice" (change)="changeCheckboxState($event, 'price')" name="couponType"
            [checked]="coupon.couponByPrice" [disabled]="inputsDisabled">
          {{'PRICE_COUPON' | translate}}
        </label>
      </div>

      <div [hidden]="!isByPercentage" class="form-row form-group">
        <div class="form-group-half">
          <label class="form-label" for="couponMinPrice">{{'PERCENTAGE_VALUE' | translate}}</label>
          <input type="number" min="0" class="form-control" id="couponMinPrice" placeholder="%" formControlName="couponPercentageValue"
            (input)="changeObjectValue($event, 'percentage')" value="{{coupon.couponPercentageValue}}" />

            <div class="alert-span" *ngIf="couponFormValidation['couponPercentageValue'].touched && couponFormValidation['couponPercentageValue'].invalid">
              <label class="error-message" *ngIf="couponFormValidation['couponPercentageValue'].errors?.['required']">
                {{ 'REQUIRED_FIELD' | translate }}
              </label>
              <label class="error-message" *ngIf="couponFormValidation['couponPercentageValue'].errors?.['min'] || couponFormValidation['couponPercentageValue'].errors?.['max']">
                {{ 'PERCENTAGE_NOT_ALLOWED' | translate }}
              </label>
            </div>
        </div>

        <div class="form-group-half">
          <label class="form-label" for="couponQuantity">{{'QUANTITY' | translate}}</label>
          <select class="form-control" id="couponQuantity" placeholder="Cantidad de cupones"
                  formControlName="couponQuantity" (change)="changeCouponQuantity($event)">
            <option [value]="999999">{{ 'UNLIMITED' | translate }}</option>
            <option *ngFor="let quantity of quantityArray" [value]="quantity">{{ quantity }}</option>
          </select>
        </div>
      </div>

      <div [hidden]="isByPercentage" class="form-row form-group">

        <div class="form-group-half">
          <label class="form-label" for="couponPrice">{{'MONETARY_VALUE' | translate}}</label>
          <input min="0" class="form-control" id="couponPrice" placeholder="{{ 'COUPON_VALUE' | translate }}" formControlName="couponPriceValue"
          (input)="changeObjectValue($event, 'price')" value="{{coupon.couponPriceValue}}"/>

            <div class="alert-span" *ngIf="couponFormValidation['couponPriceValue'].touched && couponFormValidation['couponPriceValue'].invalid">
              <label class="error-message" *ngIf="couponFormValidation['couponPriceValue'].errors?.['required']">
                {{ 'REQUIRED_FIELD' | translate }}
              </label>
              <label class="error-message" *ngIf="couponFormValidation['couponPriceValue'].errors?.['min']">
                {{ 'AMOUNT_NOT_ALLOWED' | translate }}
              </label>
            </div>
        </div>

        <div class="form-group-half">
          <label class="form-label" for="couponQuantity2">{{'QUANTITY' | translate}}</label>
          <select class="form-control" id="couponQuantity2" placeholder="Cantidad de cupones"
                  formControlName="couponQuantity" (change)="changeCouponQuantity($event)">
            <option [value]="999999">{{ 'UNLIMITED' | translate }}</option>
            <option *ngFor="let quantity of quantityArray" [value]="quantity">{{ quantity }}</option>
          </select>
        </div>

      </div>

      <div class="form-group visually-hidden">
        <label class="form-label" for="couponMaxDiscountPrice">{{'MAXIMUM_VALUE' | translate}}</label>
        <input type="number" min="0" class="form-control" id="couponMaxDiscountPrice"
          placeholder="{{ 'MAX_PURCHASE_VALUE' | translate }}" formControlName="couponMaxValue"
          (input)="changeObjectValue($event, 'maxDiscount')" value="{{coupon.couponMaxCost}}"/>

          <div class="alert-span" *ngIf="couponFormValidation['couponMaxValue'].touched && couponFormValidation['couponMaxValue'].invalid">
            <label class="error-message" *ngIf="couponFormValidation['couponMaxValue'].errors?.['required']">
              {{ 'REQUIRED_FIELD' | translate }}
            </label>
            <label class="error-message" *ngIf="couponFormValidation['couponMaxValue'].errors?.['min']">
              {{ 'AMOUNT_NOT_ALLOWED' | translate }}
            </label>
          </div>


      </div>

      <hr class="visually-hidden">
      <label class="form-label visually-hidden">{{'RESTRICTIONS' | translate}}</label>
      <div class="form-row visually-hidden">
        <label for="couponLimitByCost" class="form-label checkbox-label">
          <input type="checkbox" id="couponLimitByCost" (change)="changeCheckboxState($event, 'limitByCost')"
          [checked]="!limitByCost" [disabled]="inputsDisabled">
          {{ 'LIMIT_BY_PURCHASE_VALUE' | translate }}
        </label>

        <label for="limitByArticlesQuantity" class="form-label checkbox-label">
          <input type="checkbox" id="limitByArticlesQuantity" [disabled]="inputsDisabled"
            (change)="changeCheckboxState($event, 'limitByArticlesQuantity')" [checked]="!limitByArticlesQuantity">
          {{ 'LIMIT_BY_ITEM_QUANTITY' | translate }}
        </label>
      </div>

      <div [hidden]="limitByCost" class="form-group">

        <label class="form-label" for="couponMinPrice">{{'MINIMUM_VALUE' | translate}}</label>
        <input type="number" min="0" class="form-control" id="couponMinPrice"
          placeholder="{{ 'MIN_PURCHASE_VALUE' | translate }}" formControlName="couponMinPriceValue"
          (input)="changeObjectValue($event, 'minCost')" value="{{coupon.couponMinCost}}"/>

          <div class="alert-span" *ngIf="couponFormValidation['couponMinPriceValue'].touched && couponFormValidation['couponMinPriceValue'].invalid">
            <label class="error-message" *ngIf="couponFormValidation['couponMinPriceValue'].errors?.['required']">
              {{ 'REQUIRED_FIELD' | translate }}
            </label>
            <label class="error-message" *ngIf="couponFormValidation['couponMinPriceValue'].errors?.['min']">
              {{ 'AMOUNT_NOT_ALLOWED' | translate }}
            </label>
          </div>

      </div>

      <div [hidden]="limitByArticlesQuantity" class="form-group">

        <label class="form-label" for="couponMinArticlesQuantity">{{'MINIMUM_ITEM_QUANTITY' | translate}}</label>
        <input type="number" min="0" class="form-control" id="couponMinArticlesQuantity" formControlName="couponMinArticlesQuantity"
          placeholder="{{ 'MIN_ITEM_QUANTITY' | translate }}" (input)="changeObjectValue($event, 'articles')"
          value="{{coupon.couponMinArticlesQuantity}}"/>

          <div class="alert-span" *ngIf="couponFormValidation['couponMinArticlesQuantity'].touched && couponFormValidation['couponMinArticlesQuantity'].invalid">
            <label class="error-message" *ngIf="couponFormValidation['couponMinArticlesQuantity'].errors?.['required']">
              {{ 'REQUIRED_FIELD' | translate }}
            </label>
            <label class="error-message" *ngIf="couponFormValidation['couponMinArticlesQuantity'].errors?.['min']">
              {{ 'QUANTITY_NOT_ALLOWED' | translate }}
            </label>
          </div>

      </div>

      <div class="visually-hidden">
        <label for="couponUses" class="form-label checkbox-label">
          <input type="checkbox" id="couponUses" (change)="changeCheckboxState($event, 'uses')" [checked]="!limitUses"
            [disabled]="inputsDisabled">
            {{ 'LIMIT_USAGE_QUANTITY' | translate }}
        </label>
      </div>

      <div [hidden]="limitUses" class="form-group">

        <label class="form-label" for="couponMaxUses">{{'MAXIMUM_USAGE_QUANTITY' | translate}}</label>
        <input type="number" min="0" class="form-control" id="couponMaxUses" placeholder="{{ 'MAX_COUPON_USAGE_LIMIT' | translate }}" formControlName="couponMaxUses"
        (input)="changeObjectValue($event, 'maxUses')" value="{{coupon.couponMaxUses}}"/>

        <div class="alert-span" *ngIf="couponFormValidation['couponMaxUses'].touched && couponFormValidation['couponMaxUses'].invalid">
            <label class="error-message" *ngIf="couponFormValidation['couponMaxUses'].errors?.['required']">
              {{ 'REQUIRED_FIELD' | translate }}
            </label>
            <label class="error-message" *ngIf="couponFormValidation['couponMaxUses'].errors?.['min']">
              {{ 'QUANTITY_NOT_ALLOWED' | translate }}
            </label>
          </div>

      </div>

      <hr>

      <div class="form-group">
        <label class="form-label" for="couponDateStart">{{'COUPON_START_DATE' | translate}}</label>
        <input type="datetime-local" class="form-control" id="couponDateStart" formControlName="couponDateStart" [disabled]="inputsDisabled"/>
        <div class="alert-span" *ngIf="couponFormValidation['couponDateStart'].touched && couponFormValidation['couponDateStart'].invalid">
          <label class="error-message" *ngIf="couponFormValidation['couponDateStart'].errors?.['required']">
            {{ 'REQUIRED_FIELD' | translate }}
          </label>
        </div>
      </div>

      <div class="form-group">
        <label class="form-label" for="couponDateEnd">{{'COUPON_END_DATE' | translate}}</label>
        <input type="datetime-local" class="form-control" id="couponDateEnd" formControlName="couponDateEnd" [disabled]="inputsDisabled"/>
        <div class="alert-span" *ngIf="couponFormValidation['couponDateEnd'].touched && couponFormValidation['couponDateEnd'].invalid">
          <label class="error-message" *ngIf="couponFormValidation['couponDateEnd'].errors?.['required']">
            {{ 'REQUIRED_FIELD' | translate }}
          </label>
        </div>
      </div>

      <div class="form-group visually-hidden">
        <label class="form-label" for="product_category">{{'CATEGORY' | translate}}</label>
        <select class="form-select" id="categoryParentCategory" (change)="changeCategoryId($event, 1)"
          [disabled]="inputsDisabled">
          <option *ngIf="coupon.couponId !== 0">
            {{ coupon.couponCategoryName }}
          </option>
          <option selected hidden disabled value="null"></option>
          <option *ngFor="let category of categories" [value]="category.categoryId">
            {{ category.categoryName }}
          </option>
        </select>
      </div>

      <div class="form-group visually-hidden">
        <label class="form-label" for="product_category">{{'SUBCATEGORY' | translate}}</label>
        <select class="form-select" id="categoryParentCategory" (change)="changeCategoryId($event, 0)"
          [disabled]="inputsDisabled">
          <option *ngIf="coupon.couponId !== 0">
            {{ coupon.couponSubCategoryName }}
          </option>
          <option selected hidden disabled value="null"></option>
          <option *ngFor="let subCategory of subCategories" [value]="subCategory.categoryId">
            {{ subCategory.categoryName }}
          </option>
        </select>
      </div>

      <div class="form-group visually-hidden">
        <label class="form-label" for="product_category">{{'PRODUCT' | translate}}</label>
        <select class="form-select" id="categoryParentCategory" disabled>
          <option selected disabled hidden>{{ 'SELECT_PRODUCT' | translate }}</option>
          <option value="0">{{'NONE' | translate}}</option>
          <option>
          </option>
        </select>
      </div>

      <div class="form-group">
        <label for="couponActive" class="form-label checkbox-label">
          <input type="checkbox" id="couponActive" (change)="changeCheckboxState($event, '')"
            [checked]="coupon.couponActive" [disabled]="inputsDisabled">
            {{ 'COUPON_ACTIVE' | translate }}
        </label>
      </div>

      <div class="buttons-container">
        <button type="button" class="btn btn-outline-secondary primary-btn" (click)="enabledInputs()"
          [hidden]="!inputsDisabled">
          {{'MODIFY' | translate}}
        </button>
        <button type="button" class="btn btn-outline-secondary confirm-btn" (click)="validateFormData()"
          [hidden]="inputsDisabled">
          {{'ACCEPT' | translate}}
        </button>
        <button type="button" class="btn btn-outline-secondary cancel-btn" (click)="cancel()"
          [hidden]="inputsDisabled">
          {{'CANCEL' | translate}}
        </button>
      </div>
    </form>
  </div>

  <app-confirmation-modal *ngIf="saveCoupon"
  [title]="'COUPON_CREATED_SUCCESS' | translate"
  [message]="'CREATE_ANOTHER_COUPON' | translate"
  [cancelText]="'NO_GO_TO_COUPON_LIST' | translate"
  [confirmText]="'YES_CREATE_ANOTHER_COUPON' | translate"
  (response)="addModal($event)">
</app-confirmation-modal>


<app-confirmation-modal *ngIf="modifyCoupon"
    [title]="'COUPON_UPDATED' | translate"
    [message]="'COUPON_UPDATED_SUCCESS' | translate"
    [confirmText]="'BACK_TO_COUPONS' | translate"
    [twoFieldModal]="false"
    (response)="updateModal($event)">
</app-confirmation-modal>
<app-footer></app-footer>
